import { HttpStatusCode } from "axios";
import { alertConstants } from "../../helper/sweet-alert";
import TrainingBlockService from "../../apiServices/masters/trainingService";
import { setTrainigBlock, setTrainigBlocks } from "../../store/slices/master/trainingBlockSlice";
import trainingCompletionDetailsService from "../../apiServices/staff/trainingCompletionDetailsService";

export function getTrainingBlock(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await TrainingBlockService.getTrainingBlock(id);
    if (response?.success === true) {
      dispatch(setTrainigBlock(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getTrainingBlocks(pageBlockId?: number, noOfItems?: number, configUserType?: number) {
  return async function (dispatch: any, getState: any) {
    let response = await TrainingBlockService.getTrainingBlocks(pageBlockId, noOfItems, configUserType);
    if (response?.success === true) {
      dispatch(setTrainigBlocks(response.data));
    } else {
      console.log("error");
    }
  };
}


export function createTrainingBlock(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await TrainingBlockService.createTrainingBlock(data);
    const name = data.get("name")
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict, name);
      }
      else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateTrainingBlock(data: any, id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await TrainingBlockService.updateTrainingBlock(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateTrainingBlockPriority(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await TrainingBlockService.updateTrainingBlockPriority(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      callback(alertConstants.error);
    }
  };
}

export function deleteTrainingBlock(id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await TrainingBlockService.deleteTrainingBlock(id);
    if (response === true) {
      callback(alertConstants.inactiveSuccess);
    } else {
      callback(alertConstants.inactiveFailure);
    }
  };
}

export function updateTrainingRegisterAndAttend(id: number) {
  return async function () {
    let response = await trainingCompletionDetailsService.updateTrainingRegisterAndAttend(id);
    if (response?.success === true) {
      console.log("status update success");
    } else {
      console.log("status update failed");
    }
  };
}
